/// <reference path="../../definitions/irep/irep.d.ts" />
/// <reference path="../../definitions/pagedown/pagedown.d.ts" />
/// <reference path="../../definitions/select2/select2.d.ts" />
/// <reference path="../../public/irep.ts" />
/// <reference path="../../public/component.ts" />
/// <reference path="../../public/retailerSearch.ts" />
/// <reference path="../../public/storeManualEntry.ts" />

declare var irep: IREP.IREP;

namespace IREP {

    export interface IStorePositionOptions {
        id: string;
        countryCode: string;
        countryName: string;
        retailerSearch: RetailerSearch;
        promoterRetailerSearch: RetailerSearch;
        storeManual: StoreManualEntry;
        isDre: boolean;
    }

    enum PositionIds {
        RetailSales = 300,
        OnlineSales = 301,
        CallCenter = 302,
        Promoter = 303,
        Manager = 304,
        Other = 305,
        ManagerOneStore = 306,
        ManagerMultiple = 307,
        DepartmentManager = 308,
        RegionalManager = 309
    }

    export class StorePosition extends Component {

        // Local Ids for password validation messages
        public static PositionMode = {
            RETAILER: 1,
            MANUFACTURER: 2,
            PROMOTER: 3,
            MANAGER: 4
        }

        private options: IStorePositionOptions;
        private retailerSearch: RetailerSearch;
        private promoterRetailerSearch: RetailerSearch;
        private storeManual: StoreManualEntry;

        private countryCode: string;
        private dataStatus: string;


        private storePosition: JQuery;
        private storePositionFail: JQuery;
        private storeNotListedFail: JQuery;
        private positionOptions: JQuery;
        private managerSelect: JQuery;
        private otherInfo: JQuery;
        private otherCompany: JQuery;
        private jobDescription: JQuery;
        private promoterStore: JQuery;
        private promoterRetailerRadio: JQuery;
        private promoterStoreRadio: JQuery;
        private promoterRetailerRadioSelect: JQuery;
        private promoterStoreRadioSelect: JQuery;
        private retailerSelect: JQuery;
        private storeSelect: JQuery;
        private promoterRetailerSelect: JQuery;
        private searchRetailer: JQuery;
        private searchLocation: JQuery;
        private searchPromoterRetailer: JQuery;
        private searchRetailerBtn: JQuery;
        private searchLocationBtn: JQuery;
        private searchPromoterRetailerBtn: JQuery;
        private retailerLabel: JQuery;
        private storeLocationLabel: JQuery;
        private promoterRetailerLabel: JQuery;
        private cantFindStoreLocationLabel: JQuery;
        private initializing: boolean;
        private jobPositionSelect: JQuery; 


        constructor(options: IStorePositionOptions) {
            super(options.id);
            this.options = options;
            this.retailerSearch = options.retailerSearch;
            this.promoterRetailerSearch = options.promoterRetailerSearch;
            this.storeManual = options.storeManual;
            this.countryCode = options.countryCode;

            this.storePosition = this.$component.find(".storePosition");
            this.storePositionFail = this.$component.find("#storePositionFail");
            this.storeNotListedFail = this.$component.find("#storeNotListedFail");
            this.managerSelect = this.$component.find(".managerSelect");
            this.otherInfo = this.$component.find(".otherInfo");
            this.otherCompany = this.$component.find("[name='StorePositionModel.StoreManualEntryModel.OtherCompany']");
            this.jobDescription = this.$component.find("[name='StorePositionModel.StoreManualEntryModel.sInfo.JobDescription']");
            this.promoterStore = this.$component.find("#PromoterStore");
            this.promoterRetailerRadio = this.$component.find("[name='StorePositionModel.PromoData.SpecificRetailer']");
            this.promoterStoreRadio = this.$component.find("[name='StorePositionModel.PromoData.SpecificStore']");
            this.promoterRetailerRadioSelect = this.$component.find(".promoterRetailerRadioSelect");
            this.promoterStoreRadioSelect = this.$component.find(".promoterStoreRadioSelect");
            this.retailerSelect = this.$component.find(".retailerSelect");
            this.storeSelect = this.$component.find(".storeSelect");
            this.promoterRetailerSelect = this.$component.find(".promoterRetailerSelect");
            this.searchRetailer = this.$component.find("#SearchRetailer"); //The retailer select box
            this.searchLocation = this.$component.find("#SearchLocation"); //The store select box
            this.searchPromoterRetailer = this.$component.find("#SearchPromoterRetailer"); //The promoter retailer select box
            this.searchRetailerBtn = this.$component.find(".searchRetailer");
            this.searchLocationBtn = this.$component.find(".searchLocation");
            this.searchPromoterRetailerBtn = this.$component.find(".searchPromoterRetailer");
            this.retailerLabel = this.$component.find("#RetailerLabel");
            this.storeLocationLabel = this.$component.find("#LocationLabel");
            this.promoterRetailerLabel = this.$component.find("#PromoterRetailerLabel");
            this.jobPositionSelect = this.$component.find("#jobPositionSelect"); 



            this.retailerSearch.setCountry(options.countryCode, options.countryName);
            this.promoterRetailerSearch.setPromoterCountry(options.countryCode, options.countryName);
            this.storeManual.setCountry(options.countryCode, false);


            this.initCallbacks();
            this.retailerSearch.manualForm(this.storeManual);
            this.promoterRetailerSearch.manualForm(this.storeManual);
            this.bindEvents();
            //this.updateWhatYouDo();

            if (options.isDre) {
                this.dataStatus = "DMR_ALL";
                this.updateRetailers(true);
            }

            this.initSelect2();
        }

        //When the country changes on the main registration form, this is called to update the children forms to the store position control, and to update the list of retailers in the dropdown.
        public setCountry(value: string, name: string) {
            this.countryCode = value;
            this.retailerSearch.setCountry(value, name);
            this.promoterRetailerSearch.setPromoterCountry(value, name);
            this.storeManual.setCountry(value, true);
            this.updateRetailers(false);
        }

        private bindEvents() {
            this.unbindEvents();
            this.jobPositionSelect.on("change", (e) => this.changePosition(false));
            this.promoterRetailerRadioSelect.on("change", (e) => this.promoterRetailerRadioChoice());
            this.promoterStoreRadioSelect.on("change", (e) => this.promoterStoreRadioChoice());
            this.promoterRetailerSelect.on("change", (e) => this.promoterRetailerRadioShow());
            this.retailerSelect.on("change", (e) => this.promoterStoreRadioShow());
            this.searchRetailer.on("change", (e) => { this.employeeCodeCheck(); this.changeLocationList(this.initializing); this.clearError(e); });
            this.searchLocation.on("change", (e) => this.clearError(e));
            this.searchPromoterRetailer.on("change", (e) => { this.changePromoterLocation(); this.clearError(e); });
            this.searchRetailerBtn.on("click", (e) => this.retailerOpenSearch());
            this.searchLocationBtn.on("click", (e) => this.openStoreEntry());
            this.searchPromoterRetailerBtn.on("click", (e) => this.promoterRetailerOpenSearch());

            //a custom format option callback
            function addressFormatting(text) {
                if (text.element != undefined) {
                    return $("<span class='select-multiline-format'>" + $(text.element).attr('display-text').replace("|", "</BR>") + "</span></option>");
                }
                else return $(text.text);
            }

            
            irep.callApi({ url: "localization/text", type: "GET", data: { id: 211567, cultureCode: irep.options.user.cultureCode } }).done((d) => {
                this.jobPositionSelect.select2({
                    placeholder: d.text,
                    templateResult: addressFormatting,
                    allowClear: true
                });
            }); 
        }

        private unbindEvents() {
            this.promoterRetailerRadioSelect.unbind("change");
            this.promoterStoreRadioSelect.unbind("change");
            this.jobPositionSelect.unbind('change');
            this.searchRetailer.unbind('change');
            this.searchLocation.unbind('change');
            this.searchPromoterRetailer.unbind("change")
            this.searchRetailerBtn.unbind('click');
            this.searchLocationBtn.unbind('click');
            this.searchPromoterRetailerBtn.unbind("click")
        }


        public initSelection(storePositionTypeId: number, retailerName: string, storeChainId: number, promoterAgency: string, promoterStoreId: number, storeName: string, storeId: number) {
            var qq = this;
            let val = storePositionTypeId;
            if (PositionIds[storePositionTypeId] === undefined) {
                val = PositionIds.RetailSales;
            }
            else if ([PositionIds.ManagerMultiple, PositionIds.ManagerOneStore, PositionIds.RegionalManager, PositionIds.DepartmentManager].indexOf(PositionIds[PositionIds[val]]) != -1) { //Check for specific value already set in enum for one of the manager types.
                $("input:radio[name='StorePositionModel.listName'][value='" + val + "']").click();
                val = PositionIds.Manager;
            }

            $.each(this.positionOptions, function (item, e) {
                if ($(e).attr("data-typeId") == val.toString()) {
                    qq.changePosition(true);
                }
            });
            this.jobPositionSelect.val(val.toString());
            qq.changePosition(true);

            qq.initializing = true;
            setTimeout(function () {
                qq.setRetailer(retailerName, storeChainId, true);
                qq.setPromoterRetailer(promoterAgency, promoterStoreId, true);
                qq.initPromoterRetailerTexts();
                if (storeId == 0) {
                   irep.callApi({ url: "localization/text", type: "GET", data: { id: 184274, cultureCode: irep.options.user.cultureCode } }).done((d) => {
                      //Add a store not listed record.
                      qq.searchLocation.html(qq.searchLocation.html() + "<option value='0'>" + d.text + "</option>");
                      qq.setStore(storeName, storeId);
                   });
                }
            }, 500);

            this.searchLocationBtn.removeClass('hidden');
        }

        

        public initCallbacks() {
            var qq = this;

            //To be called when the retailer callback is selected. 
            var rsCallback = (id: number, name: string): void => {
                //Create an option to add to the search retailer and set that as the selected value
                //    Note: This can create duplicate records in the select list, but that shouldn't hurt anything. 
                qq.setRetailer(name, id, true);
                if (this.promoterRetailerRadio.filter(":checked").val() == "True") qq.changeLocationList(false); else qq.setStoreNotListed();                
            };

            var prsCallback = (id: number, name: string): void => {
                //Create an option to add to the search retailer and set that as the selected value
                //    Note: This can create duplicate records in the select list, but that shouldn't hurt anything. 
                qq.setPromoterRetailer(name, id, true);
                if (this.promoterRetailerRadio.filter(":checked").val() == "False") qq.changeLocationList(false); else qq.setStoreNotListed();                                
            };

            var snlCallback = (storeId: number): void => {
                //Callback to set "Store Not Listed" when you finish filling in the manual entry form
                if (storeId == 0) {
                    qq.setStoreNotListed();
                } else {
                    var snl = $("#SearchLocation option[value='" + storeId + "']");
                    if (snl.length > 0) {
                        this.searchLocation.val(snl.attr("value")).trigger('change');
                    }
                }
            }

            var rsnlCallback = (retailerId: number, storeId: number): void => {
                //Callback to set "Retailer Not Listed" and "Store Not Listed" when you finish filling in the manual entry form
                if (retailerId == 0) {
                    qq.setRetailerNotListed();
                    qq.setStoreNotListed();
                }
                else {
                    var stnl = $("#SearchRetailer option[value='" + retailerId + "']");
                    if (stnl.length > 0) {
                        this.searchLocation.val(stnl.attr("value"));
                    }
                }

                if (storeId == 0) {
                    qq.setStoreNotListed();
                } else {
                    var snl = $("#SearchLocation option[value='" + storeId + "']");
                    if (snl.length > 0) {
                        this.searchLocation.val(snl.attr("value")).trigger('change');
                    }
                }
            }           

            var prsnlCallback = (retailerId: number, storeId: number): void => {
                //Callback to set "Promoter Retailer Not Listed" and "Store Not Listed" when you finish filling in the manual entry form
                if (retailerId == 0) {
                    qq.setPromoterRetailerNotListed();
                }
                else {
                    var stnl = $("#SearchPromoterRetailer option[value='" + retailerId + "']");
                    if (stnl.length > 0) {
                        this.searchLocation.val(stnl.attr("value"));
                    }
                }

                if (storeId == 0) {
                    qq.setStoreNotListed();
                } else {
                    var snl = $("#SearchLocation option[value='" + storeId + "']");
                    if (snl.length > 0) {
                        this.searchLocation.val(snl.attr("value")).trigger('change');
                    }
                }
            }            


            this.storeManual.setCallback(snlCallback, this.promoterRetailerRadio.filter(":checked").val() == "True" ? prsnlCallback : rsnlCallback);
            this.retailerSearch.setCallback(rsCallback);
            this.promoterRetailerSearch.setCallback(prsCallback);

        }

        private setRetailerNotListed() {
            if (this.searchRetailer.val() != "0") { //Don't set it if it's already set. 
                irep.callApi({ url: "localization/text", type: "GET", data: { id: 184275, cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    this.setRetailer(d.text, 0, true);
                    this.setStoreNotListed();
                });
            }
        }

        private setPromoterRetailerNotListed() {
            if (this.searchPromoterRetailer.val() != "0") { //Don't set it if it's already set. 
                irep.callApi({ url: "localization/text", type: "GET", data: { id: 184275, cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    this.setPromoterRetailer(d.text, 0, true);
                });
            }
        }

        private setStoreNotListed() {
            var snl = $("#SearchLocation option[data-storenotlisted='true']");
            if (snl.length > 0) {
                this.searchLocation.val(snl.attr("value")).trigger('change');
            }
            else {
                if (this.searchLocation.val() != "0") { //Don't set it if it's already set. 
                    irep.callApi({ url: "localization/text", type: "GET", data: { id: 184274, cultureCode: irep.options.user.cultureCode } }).done((d) => {
                        this.setStore(d.text, 0);
                    });
                }
            }
        }

        //private updateWhatYouDo() {
            
        //        function updateSelected() {
	       //         let selectedOption = document.querySelector('.fd--radio--js:checked');
	       //         let selectedLabel = selectedOption.parentElement.querySelector('.fd--label');
	       //         let text = selectedLabel.textContent;
	       //         document.querySelector('.fd--selected--js').textContent = text;
        //        }

        //        function toggleClass(el, className, add) {
	       //         let addClass = add;
	       //         if (typeof addClass === 'undefined') {
		      //          addClass = !el.classList.contains(className);
	       //         }
	
	       //         if (addClass) {
		      //          el.classList.add(className);
	       //         } else {
		      //          el.classList.remove(className);
	       //         }
        //        }

        //        let radios = document.querySelectorAll('.fd--radio--js');
        //        let root = document.querySelector('.fd--root--js');

        //        for (var i = 0; i < radios.length; ++i) {
        //          var radio = radios[i];
	       //         radio.addEventListener('change', function() {
		      //          updateSelected();
	       //         });
        //            radio.addEventListener('click', function () {
		      //          toggleClass(root, 'is-active', false);
	       //         });
        //        }

        //        let selectedLabel = document.querySelector('.fd--selected--js');
        //        selectedLabel.addEventListener('click', function () {
	       //         toggleClass(root, 'is-active', true);
        //        });

        //        updateSelected();

        //}


        private setRetailer(name: string, id: number, trigger: boolean) {
                this.searchRetailer.html(this.searchRetailer.html() + "<option value='" + id.toString() + "' selected>" + name + "</option>");
                this.searchRetailer.val(id.toString());
                if (trigger) {
                    this.searchRetailer.trigger('change');
                    //this.setStoreNotListed();
                //} else {
                //    this.setStoreNotListed();
                }
        }

        private setPromoterRetailer(name: string, id: number, trigger: boolean) {
            //this.updatePromoterRetailers(false);
            this.searchPromoterRetailer.html(this.searchPromoterRetailer.html() + "<option value='" + id.toString() + "' selected>" + name + "</option>");
            this.searchPromoterRetailer.val(id.toString());

            if (trigger) {
                this.searchPromoterRetailer.trigger('change');
                //this.setStoreNotListed();
            } else {
                //this.searchPromoterRetailer.val(id.toString());
                this.setStoreNotListed();
            }
        }


        private setStore(name: string, id: number) {
            this.searchLocation.html(this.searchLocation.html() + "<option value='" + id.toString() + "' selected>" + name + "</option>");
            this.searchLocation.val(id.toString()).trigger('change');
        }

        public getResults() {
            //Trim all form fields before serialize. 
            this.storeManual.getForm().find("input").each(function () {
                this.value = $(this).val().trim();
            })

            return this.storeManual.getForm().serialize() + "&StorePositionModel.Info.StorePositionTypeId=" + this.getStorePositionId();
        }

        private getStorePositionId() {
            return (this.options.isDre) ? 300 : (this.managerSelect.is(":visible")) ? $("input:radio[name='StorePositionModel.listName']:checked").val() : $("#jobPositionSelect").val();
        }

        private changePosition(retainRetailer: boolean) {
            //Remove title attribute & hence tooltip that will say 'chain not listed / store not listed' from select2. 
            $("#select2-StorePositionModel_Info_StoreChainId-container").attr('title', '');
            $("#select2-StorePositionModel_Info_StoreId-container").attr('title', '');
            
            //hide all the things... 
            this.managerSelect.addClass('hidden');
            this.retailerSelect.removeClass('hidden');
            this.storeSelect.removeClass('hidden');
            this.promoterRetailerSelect.addClass('hidden');
            this.otherInfo.addClass('hidden');
            this.promoterRetailerRadioSelect.addClass('hidden');
            this.promoterStoreRadioSelect.addClass('hidden');
            this.dataStatus = this.jobPositionSelect.val();
            switch (this.jobPositionSelect.val()) {
                case "305":
                    $('.promoterRetailerRadioSelect input[type="radio"]').prop('checked', false);
                    $('.promoterStoreRadioSelect input[type="radio"]').prop('checked', false);
                    this.searchPromoterRetailer.val(0).trigger('change');
                    this.promoterStore.val(0).trigger('change');
                    this.otherInfo.removeClass('hidden');
                    this.retailerSelect.addClass('hidden');
                    this.storeSelect.addClass('hidden');
                    $('.employeeCode').addClass('hidden')
                    this.dataStatus = "other";
                    this.setRetailerNotListed(); //Set retailer/store not listed, since Other does not have one associated.
                    this.setStoreNotListed();
                    break;
                case "304":
                    $('.promoterRetailerRadioSelect input[type="radio"]').prop('checked', false);
                    $('.promoterStoreRadioSelect input[type="radio"]').prop('checked', false);
                    this.searchPromoterRetailer.val(0).trigger('change');
                    this.promoterStore.val(0).trigger('change');
                    this.managerSelect.removeClass('hidden');
                    $('.employeeCode').addClass('hidden')
                    this.setPositionTexts(StorePosition.PositionMode.MANAGER);
                    this.dataStatus = "retail";
                    this.updateRetailers(retainRetailer);
                    break;
                case "303":
                    this.storeSelect.addClass('hidden');
                    this.retailerSelect.addClass('hidden');
                    this.promoterRetailerSelect.removeClass('hidden');
                    $('.employeeCode').addClass('hidden')
                    this.setPositionTexts(StorePosition.PositionMode.PROMOTER);
                    this.dataStatus = "promoter";
                    this.updatePromoterRetailers(retainRetailer);
                    break;
                case "302":
                    $('.promoterRetailerRadioSelect input[type="radio"]').prop('checked', false);
                    $('.promoterStoreRadioSelect input[type="radio"]').prop('checked', false);
                    this.searchPromoterRetailer.val(0).trigger('change');
                    this.promoterStore.val(0).trigger('change');
                    this.setPositionTexts(StorePosition.PositionMode.MANUFACTURER);
                    this.dataStatus = "manufacturer";
                    this.updateRetailers(retainRetailer);
                    break;
                default:
                    $('.promoterRetailerRadioSelect input[type="radio"]').prop('checked', false);
                    $('.promoterStoreRadioSelect input[type="radio"]').prop('checked', false);
                    this.searchPromoterRetailer.val(0).trigger('change');
                    this.promoterStore.val(0).trigger('change');
                    $('.employeeCode').addClass('hidden')
                    this.setPositionTexts(StorePosition.PositionMode.RETAILER);
                    this.dataStatus = "retail";
                    this.updateRetailers(retainRetailer);
                    break;
            }
        }

        private dreLocaleId(id: number) {
            if (!this.options.isDre) { return id; }

            switch (id) {
                case 208741:  //RETAILER NAME
                case 208743:
                case 208744: return 190330;

                case 184254: //Can't Find Retailer?
                case 184268:
                case 184273: return 190331;

                case 208746:  //STORE LOCATION
                case 208745:
                case 208742: return 190332;

                case 184209: //Can't find store location?
                case 184223:
                case 184226: return 190333;

                default: return id;
            }
        }


        private promoterRetailerRadioShow() {
            if (this.searchPromoterRetailer.val() != null && this.searchPromoterRetailer.val() != "" && this.dataStatus == "promoter") {
                this.promoterRetailerRadioSelect.removeClass('hidden');
                if (this.promoterRetailerRadio.filter(":checked").val() == "False") {
                    this.storeSelect.removeClass('hidden');
                }
            }
            else {
                return;
            }
        }
        

        private promoterRetailerRadioChoice(){
            if (this.promoterRetailerRadio.filter(":checked").val() == "True") {
                this.changePromoterLocation();
                this.updateRetailers(false);
                this.storeSelect.addClass('hidden');
                this.retailerSelect.removeClass('hidden');
            }
            else if (this.promoterRetailerRadio.filter(":checked").val() == "False") {
                this.setRetailer((this.searchPromoterRetailer.select2('data'))[0].text, (this.searchPromoterRetailer.select2('data'))[0].id, false);
                $('.promoterStoreRadioSelect input[type="radio"]').prop('checked', false);
                this.changeLocationList(false);
                this.promoterStoreRadioSelect.addClass('hidden');
                this.retailerSelect.addClass('hidden');
                this.storeSelect.removeClass('hidden');
                this.setStorePositionTextPromoter();
            }
        }

        private promoterStoreRadioShow() {
            if (this.searchRetailer.val() != null && this.searchRetailer.val() != "" && this.promoterRetailerRadio.filter(":checked").val() == "True") {
                this.retailerSelect.removeClass('hidden');
                this.promoterStoreRadioSelect.removeClass('hidden');
                if (this.promoterStoreRadio.filter(":checked").val() == "True") {
                    this.storeSelect.removeClass('hidden');
                }
            }
            else {
                return;
            }
        }

        private initPromoterRetailerTexts() {
            if (this.promoterRetailerRadio.filter(":checked").val() == "True") {
                this.setStorePositionTextRetailer();
            }
            else if (this.promoterRetailerRadio.filter(":checked").val() == "False") {
                this.setStorePositionTextPromoter();
            }
        }

        private promoterStoreRadioChoice(){
            if (this.promoterStoreRadio.filter(":checked").val() == "True") {
                this.setStorePositionTextRetailer();
                this.storeSelect.removeClass('hidden');
                this.changeLocationList(false);
            }
            else if (this.promoterStoreRadio.filter(":checked").val() == "False") {
                this.storeSelect.addClass('hidden');
                this.changeLocationList(false);
                return;
            }
        }    

        private setPositionTexts(type: number) {
            var that = this;

            if (type == StorePosition.PositionMode.RETAILER || type == StorePosition.PositionMode.MANAGER) {
                irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(208741), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    that.retailerLabel.html(d.text);
                });
                irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(231064), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    $(".mtRetailerSearch.mt-select2").select2({
                        placeholder: d.text
                    });
                });
                irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(184254), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    that.searchRetailerBtn.html(d.text);
                });
                this.storeManual.setMode(StorePosition.PositionMode.RETAILER);
                this.retailerSearch.setMode(StorePosition.PositionMode.RETAILER);
            }
            else if (type == StorePosition.PositionMode.MANUFACTURER) {
                irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(208743), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    that.retailerLabel.html(d.text);
                });
                irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(231063), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    $(".mtRetailerSearch.mt-select2").select2({
                        placeholder: d.text
                    });
                });
                irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(184268), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    that.searchRetailerBtn.html(d.text);
                });

                this.storeManual.setMode(StorePosition.PositionMode.MANUFACTURER);
                this.retailerSearch.setMode(StorePosition.PositionMode.MANUFACTURER);
            }
            else if (type == StorePosition.PositionMode.PROMOTER) { //Promoter
                irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(217082), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    that.retailerLabel.html(d.text);
                });
                irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(231061), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    $(".mtPromoterRetailerSearch.mt-select2").select2({
                        placeholder: d.text
                    });
                });
                irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(231059), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    $(".mtRetailerSearch.mt-select2").select2({
                        placeholder: d.text
                    });
                });
                irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(217087), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    that.searchRetailerBtn.html(d.text);
                });

                this.storeManual.setMode(StorePosition.PositionMode.PROMOTER);
                this.promoterRetailerSearch.setMode(StorePosition.PositionMode.PROMOTER);
                this.retailerSearch.setMode(StorePosition.PositionMode.PROMOTER);
            }

            //Do the store location update separately, because promises. 
            if (type == StorePosition.PositionMode.MANAGER) {
                irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(208746), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    that.storeLocationLabel.html(d.text);
                });
                irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(184209), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    that.searchLocationBtn.html(d.text);
                });
            } else if (type == StorePosition.PositionMode.MANUFACTURER) {
                irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(208745), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    that.storeLocationLabel.html(d.text);
                });
                irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(184250), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    $(".mtSearchLcoation.mt-select2").select2({
                        placeholder: d.text
                    });
                });
                irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(184223), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    that.searchLocationBtn.html(d.text);
                });
            } else if (type == StorePosition.PositionMode.PROMOTER) {
                this.setStorePositionTextPromoter(); 
            } else {
                this.setStorePositionTextRetailer(); 
            }
        }

        private setStorePositionTextRetailer() {
            var that = this;
            irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(208742), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                that.storeLocationLabel.html(d.text);
            });
            irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(184250), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                $(".mtSearchLcoation.mt-select2").select2({
                    placeholder: d.text
                });
            });
            irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(184209), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                that.searchLocationBtn.html(d.text);
            });
        }

        private setStorePositionTextPromoter() {
            var that = this;
            irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(208744), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                that.storeLocationLabel.html(d.text);
            });
            irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(184250), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                $(".mtSearchLcoation.mt-select2").select2({
                    placeholder: d.text
                });
            });
            irep.callApi({ url: "localization/text", type: "GET", data: { id: that.dreLocaleId(231060), cultureCode: irep.options.user.cultureCode } }).done((d) => {
                that.searchLocationBtn.html(d.text);
            });
        }

        private retailerOpenSearch() {
            var qq = this;

            this.retailerSearch.openSearch();
        }

        private promoterRetailerOpenSearch() {
            var qq = this;

            this.promoterRetailerSearch.openSearch();
        }

        private clearError(e: JQueryEventObject) {
            $(e.target).closest('.has-error').removeClass('has-error');
        }

        //Open the store form. 
        private openStoreEntry() {
            this.storeManual.open(false);
        }

        private updatePromoterRetailers(retainRetailer: boolean) {
            var qq = this;

            $.ajax({
                type: "get",
                dataType: "json",
                url: irep.options.appUrl + 'RetailersByAttribute',
                data: { countryCode: this.countryCode, attribute: "promoter" }
            }).done(function (d) {
                var listItems = "<option></option>"; //blank option means we won't have a default selection taken.
                for (var i = 0; i < d.Data.length; i++) {
                    listItems += "<option value='" + d.Data[i].Id + "'>" + d.Data[i].Name + "</option>";
                }
                if (retainRetailer) {
                    qq.searchPromoterRetailer.html(qq.searchPromoterRetailer.html() + listItems);
                    qq.searchPromoterRetailerBtn.removeClass('hidden');
                }
                else {
                    qq.searchPromoterRetailer.html(listItems);
                    qq.searchPromoterRetailerBtn.removeClass('hidden');
                    qq.searchPromoterRetailer.val(null).trigger('change');
                }
            });

        }

        //Get the list of available retailers, and then blank the current selected location. 
        private updateRetailers(retainRetailer: boolean) {
            if (this.dataStatus == "other" || this.dataStatus == undefined) return;
            var ApiCmd = 'RetailersByAttribute';
            if (this.dataStatus == 'retail' || this.dataStatus == 'online' || this.promoterRetailerRadio.filter(":checked").val() != undefined) ApiCmd = 'PreferredRetailers';
            var qq = this;
            var currentRetailerId = this.searchRetailer.val();

            $.ajax({
                type: "get",
                dataType: "json",
                url: irep.options.appUrl + ApiCmd,
                data: { countryCode: this.countryCode, attribute: this.dataStatus }
            }).done(function (d) {
                var listItems = "<option></option>"; //blank option means we won't have a default selection taken.
                for (var i = 0; i < d.Data.length; i++) {
                    listItems += "<option value='" + d.Data[i].Id + "'>" + d.Data[i].Name + "</option>";
                }
                if (retainRetailer) {
                    qq.searchRetailer.html(qq.searchRetailer.html() + listItems);
                }
                else {
                    qq.searchRetailer.html(listItems);
                    qq.searchRetailer.val(null).trigger('change'); //Remove selected store chain 
                    qq.searchLocation.val(null).trigger('change');
            }
            });
        }

        private processGermanLogic() {
            var that = this;
            /* When the country is germany, and the selected retailer is one of these 15, the age requirement text needs to say "16 or older", instead of "18 or older" */
            if ($.inArray(this.promoterRetailerRadio.filter(":checked").val() == "True" ? this.searchPromoterRetailer.val() : this.searchRetailer.val(), ["204552", "28101", "28057", "151552", "31643", "884", "912", "104620", "1516", "1531", "287877", "170664", "211277", "31649", "284489", "2048", "1838", "289810"]) != -1) {
                irep.callApi({ url: "localization/text", type: "GET", data: { id: 190658, cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    $("#AgeDisclaimer1 .control-label").html(d.text);
                });
            } else {
                irep.callApi({ url: "localization/text", type: "GET", data: { id: 184237, cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    $("#AgeDisclaimer1 .control-label").html(d.text);
                });

            }
        }

        private changePromoterLocation() {
            if (this.countryCode == "DE") { this.processGermanLogic(); }

            if (this.dataStatus != "promoter") return;
            var currentLocationId = this.searchLocation.val();

            var qq = this;

            if (this.promoterRetailerRadio.filter(":checked").val() == "True") {
                $.ajax({
                    type: "get",
                    dataType: "json",
                    url: irep.options.appUrl + "StoreList",
                    data: {
                        storeChainId: this.searchPromoterRetailer.val(),
                        countryCode: this.countryCode
                    }
                }).done(function (d) {
                    var storeNotListed;

                    for (var i = 0; i < d.Data.length; i++) {
                        if (d.Data[i].IsStoreNotListed == true) {
                            storeNotListed += "<option select value='" + d.Data[i].Id + "' data-storeNotListed='" + d.Data[i].IsStoreNotListed + "'>" + d.Data[i].Name + "</option>";
                            break;
                        }
                    }
                    qq.promoterStore.html(storeNotListed);

                });
            }
            else if (this.promoterRetailerRadio.filter(":checked").val() == "False") {
                qq.changeLocationList(true);
            }
        }        

        //Get the list of stores for the retailer that was selected
        private changeLocationList(retainRetailer: boolean) {
            if (this.countryCode == "DE") { this.processGermanLogic(); }
            if (this.searchRetailer.val() == "" && this.dataStatus != "promoter") return;
            if (this.dataStatus == "other" || this.dataStatus == undefined) return;
            var currentLocationId = this.searchLocation.val();

            var qq = this;
            //this.searchLocation.val(null).trigger('change');
            if (this.dataStatus == "promoter"){
                if (this.promoterRetailerRadio.filter(":checked").val() == "True" && this.promoterStoreRadio.filter(":checked").val() == "False" &&  qq.searchRetailer.val() != "") {
                    $.ajax({
                        type: "get",
                        dataType: "json",
                        url: irep.options.appUrl + "StoreList",
                        data: {
                            storeChainId: this.searchRetailer.val(),
                            countryCode: this.countryCode
                        }
                    }).done(function (d) {
                        var storeNotListed;

                        for (var i = 0; i < d.Data.length; i++) {
                            if (d.Data[i].IsStoreNotListed == true) {
                                storeNotListed += "<option select value='" + d.Data[i].Id + "' data-storeNotListed='" + d.Data[i].IsStoreNotListed + "'>" + d.Data[i].Name + "</option>";
                                break;
                            }
                        }
                        qq.searchLocation.val(null).trigger('change');
                        qq.searchLocation.html(storeNotListed);

                    });
                }
                else if (this.promoterRetailerRadio.filter(":checked").val() == "True" && this.promoterStoreRadio.filter(":checked").val() == "True") {
                    $.ajax({
                        type: "get",
                        dataType: "json",
                        url: irep.options.appUrl + "StoreList",
                        data: {
                            storeChainId: this.searchRetailer.val(),
                            countryCode: this.countryCode
                        }
                    }).done(function (d) {
                        qq.searchLocationBtn.removeClass('hidden');
                        var listItems = "<option></option>";

                        for (var i = 0; i < d.Data.length; i++) {
                            listItems += "<option value='" + d.Data[i].Id + "' data-storeNotListed='" + d.Data[i].IsStoreNotListed + "'>" + d.Data[i].Name + "</option>";
                        }
                        qq.searchLocation.html(listItems);

                        if (retainRetailer) {
                            qq.searchLocation.val(currentLocationId).trigger('change');
                        }
                        else {
                            qq.searchLocation.val(null).trigger('change');
                        }
                        qq.initializing = false;
                        });
                }
                else if (this.promoterRetailerRadio.filter(":checked").val() == "False" && this.searchPromoterRetailer.val() != "" && this.searchPromoterRetailer.val() != null) {
                    $.ajax({
                        type: "get",
                        dataType: "json",
                        url: irep.options.appUrl + "StoreList",
                        data: {
                            storeChainId: this.searchPromoterRetailer.val(),
                            countryCode: this.countryCode
                        }
                    }).done(function (d) {
                        qq.searchLocationBtn.removeClass('hidden');
                        var listItems = "<option></option>";

                        for (var i = 0; i < d.Data.length; i++) {
                            listItems += "<option value='" + d.Data[i].Id + "' data-storeNotListed='" + d.Data[i].IsStoreNotListed + "'>" + d.Data[i].Name + "</option>";
                        }
                        qq.searchLocation.html(listItems);

                        if (retainRetailer) {
                            qq.searchLocation.val(currentLocationId).trigger('change');
                        }
                        else {
                            qq.searchLocation.val(null).trigger('change');
                        }
                        qq.initializing = false;
                    });
                }

            }
            else{
                $.ajax({
                    type: "get",
                    dataType: "json",
                    url: irep.options.appUrl + "StoreList",
                    data: {
                        storeChainId: this.searchRetailer.val(),
                        countryCode: this.countryCode
                    }
                }).done(function (d) {
                    qq.searchLocationBtn.removeClass('hidden');
                    var listItems = "<option></option>";

                    for (var i = 0; i < d.Data.length; i++) {
                        listItems += "<option value='" + d.Data[i].Id + "' data-storeNotListed='" + d.Data[i].IsStoreNotListed + "'>" + d.Data[i].Name + "</option>";
                    }
                    qq.searchLocation.html(listItems);

                    if (retainRetailer) {
                        qq.searchLocation.val(currentLocationId).trigger('change');
                    }
                    else {
                        qq.searchLocation.val(null).trigger('change');
                    }

                    qq.initializing = false;
                });
            }            
        }

        private employeeCodeCheck() {
            if ((this.searchRetailer.val() == "39041" || this.searchRetailer.val() == "129859") && this.dataStatus != 'promoter') {
                $('.employeeCode').removeClass('hidden');
            }
            else {
                $('.employeeCode').addClass('hidden');
            }
        }

        //Validate the form is OK to submit
        public Validate() {
            //Clear previous errors... 
            this.retailerSelect.removeClass('has-error');
            this.storeSelect.removeClass('has-error');
            this.promoterRetailerSelect.removeClass('has-error');
            this.promoterRetailerRadioSelect.removeClass('has-error');
            this.promoterStoreRadioSelect.removeClass('has-error');
            this.managerSelect.removeClass('has-error');
            this.searchLocationBtn.removeClass('has-error');
            this.searchRetailerBtn.removeClass('has-error');
            this.searchPromoterRetailerBtn.removeClass('has-error');
            this.jobDescription.parent().removeClass('has-error');
            this.otherCompany.parent().removeClass('has-error');
            this.storePositionFail.addClass('hidden');
            this.storeNotListedFail.addClass('hidden');

            var res = true;

            if (this.jobPositionSelect.val() == "" ) {
                this.storePosition.addClass('has-error');
                this.storePositionFail.removeClass('hidden');
                res = false;
            }

            if (this.retailerSelect.is(":visible") && (this.searchRetailer.val() == null || this.searchRetailer.val() == "")) {
                this.retailerSelect.addClass('has-error');
                res = false;
            }

            if (this.storeSelect.is(":visible") && (this.searchLocation.val() == null || this.searchLocation.val() == "")) {
                this.storeSelect.addClass('has-error');
                res = false;
            }

            if (this.dataStatus == "other" && this.otherInfo.is(":visible")) {
                if (this.otherCompany.val() == null || this.otherCompany.val().trim() == "") {
                    this.otherCompany.parent().addClass('has-error');
                    res = false;
                }
                if (this.jobDescription.val() == null || this.jobDescription.val().trim() == "") {
                    this.jobDescription.parent().addClass('has-error');
                    res = false;
                }
            }

            if (this.dataStatus == "promoter" && this.promoterRetailerSelect.is(":visible")) {
                if(this.searchPromoterRetailer.val() == null || this.searchPromoterRetailer.val() == ""){
                    this.promoterRetailerSelect.addClass('has-error');
                    res = false;
                }
                if (this.searchPromoterRetailer.val() == "0" && !this.storeManual.isValid(true) && !this.otherInfo.is(":visible")) {
                    this.searchPromoterRetailerBtn.addClass('has-error');
                    res = false;
                }
                if (this.promoterRetailerRadioSelect.is(":visible") && this.promoterRetailerRadio.filter(":checked").val() == undefined) {
                    this.promoterRetailerRadioSelect.addClass('has-error');
                    res = false;
                }

                if (this.promoterStoreRadioSelect.is(":visible") && this.promoterStoreRadio.filter(":checked").val() == undefined) {
                    this.promoterStoreRadioSelect.addClass('has-error');
                    res = false;
                }
            }



            //Validate retailer not selected form.
            if ((this.searchLocation.val() == "0" || $("#SearchLocation :selected").attr('data-storenotlisted') == "true") && this.dataStatus != "promoter" && !this.storeManual.isValid(false) && !this.otherInfo.is(":visible")) {
                this.searchLocationBtn.addClass('has-error');
                this.storeNotListedFail.removeClass('hidden');
                res = false;
            }

            //Validate retailer not selected form.
            if (this.searchRetailer.val() == "0" && !this.storeManual.isValid(true) && !this.otherInfo.is(":visible")) {
                this.searchRetailerBtn.addClass('has-error');
                res = false;
            }

            if (this.managerSelect.is(":visible") && $("input:radio[name='StorePositionModel.listName']:checked").length == 0) {
                this.managerSelect.addClass('has-error');
                res = false;
            }

            return res;
        }

        private initSelect2() {
            var qq = this;
            //Has to be called after object initialization
            $(".mtRetailerSearch.mt-select2").select2({
                minimumInputLength: 0,
                ajax: {
                    url: irep.options.appUrl + "SearchRetailers",
                    dataType: 'json',
                    data: function (params) {
                        return { CountryCode: qq.countryCode, SearchText: (params as any).term, IsDre: qq.options.isDre, Limit: 100, Attribute: qq.dataStatus == "promoter" ? "retail" : qq.dataStatus  }
                    },
                    processResults: function (data) {
                        return {
                            results: $.map(data.Data, function (item) {
                                return {
                                    text: item.Name,
                                    id: item.Id
                                }
                            })
                        };
                    }
                }
            });
            $(".mtPromoterRetailerSearch.mt-select2").select2({
                minimumInputLength: 0,
                ajax: {
                    url: irep.options.appUrl + "SearchRetailers",
                    dataType: 'json',
                    data: function (params) {
                        return { CountryCode: qq.countryCode, SearchText: (params as any).term, IsDre: qq.options.isDre, Limit: 100, Attribute: qq.dataStatus }
                    },
                    processResults: function (data) {
                        return {
                            results: $.map(data.Data, function (item) {
                                return {
                                    text: item.Name,
                                    id: item.Id
                                }
                            })
                        };
                    }
                }
            });

        }
    }

}